export default [{
    path: '/content/information/RotationChartDetail',
    component: resolve => require(['../pages/information/RotationChartDetail.vue'], resolve),
    title: '专家风采'
}];



// WEBPACK FOOTER //
// ./src/content/portalSite/router/RotationChartRouter.js